import storage from "storage"
import rollbarHelper from "./rollbar_helper"

// stores alrady created sounds with their identifier
// so we can reuse them later e.g. trainer
let sounds = {}

// Firefox doesn't support navigator.userActivation
// https://stackoverflow.com/a/76001567
if (!window.navigator.userActivation) {
  navigator.userActivation = {hasBeenActive: false}
  function pageActivationClickHandler(e) {
    if (e.isTrusted) {
      navigator.userActivation.hasBeenActive = true
      window.removeEventListener("click", pageActivationClickHandler)
    }
  }
  window.addEventListener("click", pageActivationClickHandler)
}

const soundHelper = {
  // the trainer waits for the audio to be finished
  // this value determines the max waiting time
  // it is set to 0 in the js test environment
  minimumAudioDuration: 5000,

  play(audio, options = {}) {
    if (options.autoPlay && !this.canAutoPlay()) return Promise.resolve()
    if (!options.ignoreMuted && storage.get("kenhub_sound_muted")) {
      return Promise.resolve()
    }

    const sound = this.createSound(audio)
    return sound.play().catch((e) => {
      rollbarHelper.sendErrorMsg(e, {audio})
    })
  },

  canAutoPlay: () => window.navigator.userActivation.hasBeenActive,

  createSound: (audioUrl) => {
    if (sounds[audioUrl]) return sounds[audioUrl]

    sounds[audioUrl] = new Audio(audioUrl)
    return sounds[audioUrl]
  },

  isMuted: () => !!storage.get("kenhub_sound_muted"),

  mute: () => {
    storage.set("kenhub_sound_muted", true)
  },

  unmute: () => {
    storage.set("kenhub_sound_muted", false)
  },

  clear: () => (sounds = {})
}

export default soundHelper
